import React, { useState } from "react";

const CopyCell = ({ apiKey }) => {
  const [copied, setCopied] = useState(false);

  // Fallback method for non-secure contexts
  const unsecuredCopyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Fallback copy failed:", err);
    } finally {
      document.body.removeChild(textArea);
    }
  };

  const handleCopy = async () => {
    try {
      // Check if clipboard API is available (secure context)
      if (window.isSecureContext && navigator.clipboard) {
        await navigator.clipboard.writeText(apiKey);
      } else {
        // Use fallback for non-HTTPS environments
        unsecuredCopyToClipboard(apiKey);
      }
      
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Failed to copy:", err);
      // Try fallback if clipboard API fails
      unsecuredCopyToClipboard(apiKey);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <div className="relative flex items-center gap-2">
      <code className="rounded bg-gray-100 px-2 py-1 font-mono text-xs">
        {apiKey.slice(0, 4)}****{apiKey.slice(-4)}
      </code>

    { !copied && <button
        onClick={handleCopy}
        className="text-xs font-medium text-blue-600 hover:text-blue-800"
      >
        Copy
      </button>}

      {copied && (
        <span className="text-xs font-medium text-blue-600 hover:text-blue-800">
          Copied!
        </span>
      )}
    </div>
  );
};

export default CopyCell;
